import React from 'react';
import ReactDOM from 'react-dom';
import Routes from './component/Routes';
import './style/index.scss';

ReactDOM.render(<Routes />, document.getElementById('root'));
